export type AccountIconKey =
  | "provider"
  | "google"
  | "microsoft"
  | "mail"
  | "briefcase"
  | "sparkles";

export type AccountIconOption = {
  id: AccountIconKey;
  label: string;
};

/** Auto + Google + Microsoft + 3 icônes génériques. */
export const ACCOUNT_ICON_OPTIONS: AccountIconOption[] = [
  { id: "provider", label: "Auto" },
  { id: "google", label: "Google" },
  { id: "microsoft", label: "Microsoft" },
  { id: "mail", label: "Courrier" },
  { id: "briefcase", label: "Pro" },
  { id: "sparkles", label: "Perso" },
];

export function normalizeAccountIconKey(value: unknown): AccountIconKey {
  if (
    value === "provider" ||
    value === "google" ||
    value === "microsoft" ||
    value === "mail" ||
    value === "briefcase" ||
    value === "sparkles"
  ) {
    return value;
  }
  return "provider";
}
